import Vue from 'vue'
import App from './App.vue'
import router from './router'
import GoEasy from 'goeasy';

Vue.config.productionTip = false

const savedAgent = sessionStorage.getItem('currentAgent');
Vue.prototype.globalData = {
    currentAgent: savedAgent ? JSON.parse(savedAgent) : null
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

const goEasy = GoEasy.getInstance({
	host: 'hangzhou.goeasy.io',	//应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
	appkey: 'BC-64fa19a4c7754133b849c6fc56a12bef', // common key,
	modules: ['im']
});

Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;

